import i18n from "core/i18n";

const msgDateFormatter = (time: string | null | undefined) => {
  if (!time) {
    return "";
  }
  const timeStamp = Date.parse(time);
  const timeStampNow = Date.parse(new Date().toUTCString());
  const days = Math.floor(timeStamp / (24 * 60 * 60 * 1000))
  const today = Math.floor(timeStampNow / (24 * 60 * 60 * 1000))
  const diff = today - days;
  if (diff < 1) {
    return i18n.t("views.titles.today");
  } else if (diff < 2) {
    return i18n.t("views.titles.yesterday");
  } else {
    const formatter = new Intl.DateTimeFormat(i18n.language || "ru", {
      month: "long",
      day: "2-digit",
    });
    return formatter.format(new Date(time));
  }
};

export default msgDateFormatter;
